(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    const selectedMedia = document.querySelector('.product-gallery__media-list .is-selected');

if (selectedMedia) {
  const logoBlock = document.createElement('div');
  logoBlock.className = 'custom-logo-block';
  logoBlock.innerHTML = `
    <div style="
      background: #F3EFEE;
      border-radius: 10px;
      padding: 30px 50px;
      width: 100%;
      flex-basis: 100%;
      max-width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 30px;
      flex-wrap: wrap;
    ">
      <img src="https://cdn.shopify.com/s/files/1/0887/6510/4467/files/logo-elle.png?v=1749199764" alt="Logo Elle" style="width:88px; height:35px;">
      <img src="https://cdn.shopify.com/s/files/1/0887/6510/4467/files/logo-loreal.png?v=1749218893" alt="L'Oréal" style="width:130px; height:23.5px;">
      <img src="https://cdn.shopify.com/s/files/1/0887/6510/4467/files/logo-m6.png?v=1749199764" alt="Logo M6" style="width:57px; height:43px;">
      <img src="https://cdn.shopify.com/s/files/1/0887/6510/4467/files/logo-eurasante.png?v=1749218893" alt="Logo Eurasanté" style="width:80px; height:61px;">
    </div>
  `;

  selectedMedia.insertAdjacentElement('afterend', logoBlock);
}
  } catch(e) { console.error(e); }
})();

})();
